import React from "react";
import Modal from 'react-responsive-modal';
import { withTranslation } from 'react-i18next';
import './index.css';

class BaggageIcons extends React.PureComponent {
    constructor (props) {
        super(props)
        
        //console.log(this.props.baggage)
        //console.log(this.props?.airline + ' ' + this.props?.airport)
        const baggageArray = this.props?.baggage?.map(bag=>{
            switch(bag?.category_code) {
                case 'C': return {
                    code:'C',
                    nameKey:'suitcase',
                    priority: 3,
                    price: bag.price,
                    weight: bag.weight,
                    width: bag.width,
                    height: bag.height,
                    length: bag.length,
                    image: `/images/baggage/24_Suitcase.svg`};

                case 'T': return {
                    code:'T',
                    nameKey:'trolley',
                    priority: 2,
                    price: bag.price,
                    weight: bag.weight,
                    width: bag.width,
                    height: bag.height,
                    length: bag.length,
                    image: `/images/baggage/24b_Trolly.svg`};

                case 'S':  return {
                    code:'S',
                    nameKey:'backpack',
                    priority: 1,
                    price: bag.price,
                    weight: bag.weight,
                    width: bag.width,
                    height: bag.height,
                    length: bag.length,
                    image: `/images/baggage/26_Backpack3.svg`};

                default: {
                    console.log('ERROR - COULD NOT FIND BAG OF TYPE: ' + bag?.category_code); 
                    console.log(bag);
                    return {}
                    break;}
            }}).sort((a,b)=>a.priority-b.priority) ;

        this.state = {
            open: false,
            airport: this.props?.airport,
            baggage:  baggageArray// sort by priority
        }
        
    }
    
    componentDidMount() {
        
    }

    onOpenModal = (e, bag) => {
        e.preventDefault();
        e.stopPropagation();

        //this.setState((prevState) => ({ 'open': true, 'active': prevState.active}));
        this.setState({
            open: true,
            baggage: this.state?.baggage,
            bag: {
                code: bag.code,
                price: bag.price,
                weight: bag.weight,
                width: bag.width,
                height: bag.height,
                length: bag.length
            }
        })
    };

    /*onCloseModal = (e) => {
        e.preventDefault()
        //this.setState((prevState) => ({ 'open': false, 'active': prevState.active}));
        this.setState({open: false,
        baggage:this.state?.baggage})
    };*/

    onCloseModal = (e) => {
        e.preventDefault()
        e.stopPropagation();
        //this.setState((prevState) => ({ 'open': false, 'active': prevState.active}));
        this.setState((prevState)=>({
            ...prevState,
            open: false,
        }))
    };
    
    render() {
        const { open } = this.state;
        const { t } = this.props;

        //return this.props?.baggage.length;
        /*if (bagsArray && bagsArray.length > 0)
            bagsArray =  [bagsArray[0]]*/
        return (
            <div className='baggage_options' title={t('reservation.steps.baggageSelection.clickForDetails')} >
                <div className='caption'>{t('reservation.steps.baggageSelection.optionsTitle')}<br />{t('reservation.steps.baggageSelection.clickForMoreDetails')}</div>
                <div className='icons' >{
                    this.state?.baggage?.map( (bag, index) => {
                        const bagName = t(`reservation.steps.baggageSelection.categories.${bag?.nameKey}`);
                        const tooltipText = bag?.price=='0'
                            ? t('reservation.steps.baggageSelection.tooltips.included', { name: bagName, weight: bag?.weight })
                            : t('reservation.steps.baggageSelection.tooltips.additionalCost', { name: bagName, price: bag?.price });

                            return (
                                <a href="javascript:void()" onClick={e=>this.onOpenModal(e, bag)} key={`bag${index}`}>
                                    <div key={index} className={bag?.price==='0'?'bagIcon included':'bagIcon'} style={bag?.price==='0'?{color:'green'}:{color:'red'}} title={tooltipText}>
                                        <img src='/images/baggage/checkmark.svg' className='checkmark' />
                                        <img src={bag?.image} alt={bagName} className='iconImage' />
                                    </div></a>
                            )
                    })
                }</div>

                <Modal open={this.state?.open?true:false} onClose={e=>this.onCloseModal(e)} center >
                    <div dir="rtl"  className="baggage_options_modal_content" tabIndex="0">
                        {
                            this.state?.bag?.code=='S'?
                                this.state?.bag?.price==='0'?
                                    (<div><h3 dangerouslySetInnerHTML={{__html: t('reservation.steps.baggageSelection.modal.backpack.includedTitle', { weight: this.state?.bag.weight })}} />
                                    <p className='highlight' dangerouslySetInnerHTML={{__html: t('reservation.steps.baggageSelection.modal.backpack.includedDescription')}} />
                                    <p><img src='/images/baggage/backpack_slim.svg'/></p>
                                    <p>{t('reservation.steps.baggageSelection.modal.weightLabel')} {this.state?.bag?.weight} {t('common.units.kg')}</p>
                                    <p>{t('reservation.steps.baggageSelection.modal.dimensionsLabel')} {this.state?.bag?.height}x{this.state?.bag?.width}x{this.state?.bag?.length} {t('common.units.cm')}</p> </div>)
                                :
                                    (<div><h3>{t('reservation.steps.baggageSelection.modal.backpack.paidTitle', { weight: this.state?.bag.weight })}</h3>
                                    <p className='highlight'>{t('reservation.steps.baggageSelection.modal.pricePerDirectionLabel')} <strong>${this.state?.bag?.price}</strong></p>
                                    <p><strong dangerouslySetInnerHTML={{__html: t('reservation.steps.baggageSelection.modal.backpack.paidDescription')}} /></p>
                                    <p><img src='/images/baggage/backpack_slim.svg'/></p>
                                    <p>{t('reservation.steps.baggageSelection.modal.weightLabel')} {this.state?.bag?.weight} {t('common.units.kg')} </p>
                                    <p>{t('reservation.steps.baggageSelection.modal.dimensionsLabel')} {this.state?.bag?.height}x{this.state?.bag?.width}x{this.state?.bag?.length} {t('common.units.cm')}</p> </div>)
                            :''

                        }
                        
                        {
                            this.state?.bag?.code=='T'?
                                this.state?.bag?.price==='0'?

                                    (<div><h3 dangerouslySetInnerHTML={{__html: t('reservation.steps.baggageSelection.modal.trolley.includedTitle', { weight: this.state?.bag.weight })}} />
                                    <p className='highlight' dangerouslySetInnerHTML={{__html: t('reservation.steps.baggageSelection.modal.trolley.includedDescription')}} />
                                    <p><img src='/images/baggage/trolly.svg'/></p>
                                    <p>{t('reservation.steps.baggageSelection.modal.weightLabel')} {this.state?.bag?.weight} {t('common.units.kg')} </p>
                                    <p>{t('reservation.steps.baggageSelection.modal.dimensionsLabel')} {this.state?.bag?.height}x{this.state?.bag?.width}x{this.state?.bag?.length} {t('common.units.cm')} </p></div>)
                                :

                                        (<div><h3>{t('reservation.steps.baggageSelection.modal.trolley.paidTitle', { weight: this.state?.bag.weight })}</h3>
                                        <p className='highlight' dangerouslySetInnerHTML={{__html: t('reservation.steps.baggageSelection.modal.trolley.paidDescription')}} />
                                        <p><img src='/images/baggage/trolly.svg'/></p>
                                        <p className='highlight'>{t('reservation.steps.baggageSelection.modal.pricePerDirectionLabel')} <strong>${this.state?.bag?.price}</strong></p>
                                        <p>{t('reservation.steps.baggageSelection.modal.weightLabel')} {this.state?.bag?.weight} {t('common.units.kg')} </p>
                                        <p>{t('reservation.steps.baggageSelection.modal.dimensionsLabel')} {this.state?.bag?.height}x{this.state?.bag?.width}x{this.state?.bag?.length} {t('common.units.cm')}</p> </div>)

                            :''
                        }

                        {
                            this.state?.bag?.code=='C'?
                                this.state?.bag?.price==='0'?

                                    (<div><h3 dangerouslySetInnerHTML={{__html: t('reservation.steps.baggageSelection.modal.suitcase.includedTitle', { weight: this.state?.bag.weight })}} />
                                    <p className='highlight' dangerouslySetInnerHTML={{__html: t('reservation.steps.baggageSelection.modal.suitcase.includedDescription')}} />
                                    <p><img src='/images/baggage/suitcase.svg'/></p>
                                    <p>{t('reservation.steps.baggageSelection.modal.weightLabel')} {this.state?.bag?.weight} {t('common.units.kg')} </p>
                                    <p>{t('reservation.steps.baggageSelection.modal.dimensionsLabel')} {this.state?.bag?.height}x{this.state?.bag?.width}x{this.state?.bag?.length} {t('common.units.cm')} </p></div>)
                                :
                                    (<div><h3>{t('reservation.steps.baggageSelection.modal.suitcase.paidTitle', { weight: this.state?.bag.weight })}</h3>
                                    <p className='highlight' dangerouslySetInnerHTML={{__html: t('reservation.steps.baggageSelection.modal.suitcase.paidDescription')}} />
                                    <p><img src='/images/baggage/suitcase.svg'/></p>
                                    <p className='highlight'>{t('reservation.steps.baggageSelection.modal.pricePerDirectionLabel')} <strong>${this.state?.bag?.price}</strong></p>
                                    <p>{t('reservation.steps.baggageSelection.modal.weightLabel')} {this.state?.bag?.weight} {t('common.units.kg')} </p>
                                    <p>{t('reservation.steps.baggageSelection.modal.dimensionsLabel')} {this.state?.bag?.height}x{this.state?.bag?.width}x{this.state?.bag?.length} {t('common.units.cm')}</p> </div>)

                            :''
                        }
            
                        <div className="baggage-modal-close-wrapper">
                            <button onClick={e=>this.onCloseModal(e)} className="baggage-modal-close-btn" tabInex="0">{t('common.buttons.closeWindow')}</button></div>
                    
                    </div>
                </Modal>
            </div>
        )
    }
    //}
}
        
export default withTranslation()(BaggageIcons)